/**
 * VideoGallery
 * Grid display of video cards, AI videos first then user videos
 */

import { makeStyles, tokens } from '@fluentui/react-components'
import { VideoClipMultipleRegular } from '@fluentui/react-icons'
import type { VideoInfo } from '../../../../domain'
import { VideoCard } from './VideoCard'
import { PanelHeader, InlineEmptyState } from '../shared'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: tokens.spacingVerticalM,
  },
})

export interface VideoGalleryProps {
  videos: VideoInfo[]
  title?: string
  onVideoClick?: (video: VideoInfo) => void
}

export function VideoGallery({ videos, title = 'Videos', onVideoClick }: VideoGalleryProps) {
  const styles = useStyles()

  // Sort videos: AI generated first, then user created
  const sortedVideos = [...videos].sort((a, b) => {
    if (a.type === 'ai_generated' && b.type !== 'ai_generated') return -1
    if (a.type !== 'ai_generated' && b.type === 'ai_generated') return 1
    return 0
  })

  if (videos.length === 0) {
    return (
      <div className={styles.root}>
        <PanelHeader icon={<VideoClipMultipleRegular />} title={title} />
        <InlineEmptyState message="No videos available for this issue" />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <PanelHeader icon={<VideoClipMultipleRegular />} title={title} />
      <div className={styles.grid}>
        {sortedVideos.map((video) => (
          <VideoCard key={video.id} video={video} onClick={onVideoClick} />
        ))}
      </div>
    </div>
  )
}
